import request from '@/utils/request'

export function fetchDetail() {
  return request({
    url: '/my/detail',
    method: 'get'
  })
}

export function update(data) {
  return request({
    url: '/my/update',
    method: 'post',
    data
  })
}

export function password(data) {
  return request({
    url: '/my/password',
    method: 'post',
    data
  })
}
